import { createTheme } from '@mui/material/styles';

const muiTheme = createTheme({
  palette: {
    primary: {
      main: '#ffffff',
    },
    secondary: {
      main: '#ffffff20',
    },
    error: {
      main: '#fff88f',
    },
  },
});

export default muiTheme;
